<template>
    <div>   
        <div class="container">
            <div class="font-set">
                <div>
                    <div style="display: inline-block">
                        <span>{{$t('Query.inputQuery')}}：</span>
                        <el-input v-model="query.input" class="searchWidth mr10 mb10" :placeholder="$t('Query.queryUserHolder')">                   
                        </el-input>
                    </div>
                    <div style="display: inline-block">
                        <span>{{$t('Query.company')}}：</span>               
                        <el-input v-model="query.company" class="searchWidth mr10 mb10" :placeholder="$t('UserManage.company')">                   
                        </el-input>
                    </div>
                    <div style="display: inline-block">
                        <span>{{$t('Query.createTime')}}：</span>               
                        <el-date-picker v-model="query.createTime" class="timeWidth mr10 mb10" type="datetimerange" range-separator="-" 
                            :start-placeholder="$t('Query.startTime')" :end-placeholder="$t('Query.endTime')" :clearable="false"
                            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>      
                    </div>              
                    <div style="display: inline-block" class="mr10 mb10">
                        <el-button type="primary" icon="el-icon-search" @click="handleSearch">{{$t('Query.queryBtn')}}</el-button>                               
                        <el-button type="primary" icon="el-icon-refresh" @click="handleClean">{{$t('Query.resetBtn')}}</el-button>         
                    </div>  
                </div>
                    
                <div style="display: inline-block" class="mb10">
                    <!-- <el-link style="margin-right:10px" class="exportButton" :underline="false" type="primary" icon="el-icon-fota-export" :href="getExport()" target="_blank">{{$t('Button.export')}}</el-link> -->
                    <el-button type="primary" icon="el-icon-fota-export" @click="handleExport">{{$t('Button.export')}}</el-button>
                    <el-button v-if="permissions.add" type="primary" icon="el-icon-plus" @click="handleCreate">{{$t('Button.create')}}</el-button>      
                    <el-button v-if="permissions.delete" type="primary" icon="el-icon-delete" @click="delAllSelection">{{$t('Button.delete')}}</el-button>                               
                </div>               

            </div>
            <el-table
                :data="tableData.slice((curPage -1)*pagesize,curPage*pagesize)"
                stripe
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
                :cell-style="{'text-align':'center', 'padding':'0px', 'height':'38px'}" 
                :header-cell-style="{'text-align':'center'}"                
                @selection-change="handleSelectionChange"
                v-loading="loading">
                <el-table-column type="selection" width="45"></el-table-column>
                <el-table-column label="ID" width="45">
                    <template slot-scope="scope">                        
                        {{ (curPage - 1) * pagesize + scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="account" :label="$t('UserManage.userName')" width="auto" min-width="130"></el-table-column>

                <el-table-column prop="email" :label="$t('UserManage.userEmail')" width="auto" min-width="150"></el-table-column>

                <el-table-column prop="nickname" :label="$t('UserManage.company')" width="auto" min-width="130"></el-table-column>

                <el-table-column prop="register_time" :label="$t('UserManage.createTime')" width="150"></el-table-column>

                <el-table-column prop="expired_time" :label="$t('UserManage.validUntil')" width="150"></el-table-column>

                <el-table-column v-if="permissions.edit" :label="$t('UserManage.enabled')" width="80">
                    <template slot-scope="scope">
                        <el-switch                             
                            v-model="scope.row.activated"
                            @change="changeStatus(scope.row)">                            
                        </el-switch>
                    </template>
                </el-table-column> 

                <el-table-column :label="$t('Table.operation')" width="150">
                    <template slot-scope="scope">
                        <el-button v-if="permissions.edit" type="text" icon="el-icon-edit" @click="handleEdit(scope.row)">{{$t('Button.edit')}}</el-button>
                        <el-button v-if="permissions.delete" type="text" icon="el-icon-delete" @click="handleDelete(scope.row)">{{$t('Button.delete')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page.sync="curPage"
                    :page-size="pagesize"
                    :total="tableData.length"
                    :page-sizes="[10, 25, 50]"
                    @current-change="handleCurentChange"
                    @size-change="handleSizeChange"
                ></el-pagination>
            </div>  
        </div>
  

             
    </div>
</template>

<script>
import bus from '../../common/bus';
import Tools from '../../common/Tools.js';
import api from '../../../api/api.js';
import apiAllSystem from '../../../api/apiAllSystem.js';

export default {
    name: 'taskManage',
    components: {// 注册    

    },      
    data() {
        return {
            pagesize: 10, //每页显示条数
            curPage: 1,   //当前页数
            query: {
                input: '',
                company: '',
                createTime: '',
            },
            tableData: [],
            multipleSelection: [],
            permissions: {},
            loading: false
        };
    },
    created() { 
        this.permissions = this.global.permissions.userManage;
        this.getData();   
    },
    computed: {
        columns() {
            return [
                {title:this.$t('UserManage.userName'), key: 'account'},
                {title:this.$t('UserManage.userEmail'), key: 'email'},
                {title:this.$t('UserManage.company'), key: 'nickname'},
                {title:this.$t('UserManage.createTime'), key: 'register_time'},
                {title:this.$t('UserManage.validUntil'), key: 'expired_time'},
            ]   
        }
    },
    watch:{
        '$route': function (to, from) {//监听到路由（参数）改变
            // 拿到目标参数 to.query.state 去再次请求数据接口
            if(to.path == "/userManage"){
                this.getData();
            }

        }
    },    
    methods: {
        getData() {
            this.loading = true;

            let params = {
                usersssid: localStorage.getItem('sssid'),
                beginrtime: this.query.createTime[0],
                endrtime: this.query.createTime[1],
                includeSelf: false
            }

            if(this.query.input !== ""){
                params.accountemail = this.query.input;
            }
            if(this.query.company !== ""){
                params.nickname = this.query.company;
            }

            if(this.$route.query.detail){
                params.orderfirstsssid = this.$route.query.detail;
            }
            api.getUser(params)
            .then(res => {
                this.permissions = this.global.permissions.userManage;
                this.loading = false;
                if(res.state){
                    this.tableData = res.value;
                } else {
                    this.$message.error(res.value.text);
                }
            })
            .catch((error) => {
                this.$message.error(this.$t('Message.reqError'));
            });           
        },
        // 搜索
        handleSearch() {     
            
            this.getData();
            
        },

        //重置
        handleClean() {
            this.query.input = "";
            this.query.company = "";
            this.query.createTime = "";
            this.getData();
        },

        // 新建
        handleCreate(){
            this.$router.push({path:'/userCreate'});
        },

        // 删除
        handleDelete(row) {
            // 二次确认删除
            this.$confirm(this.$t('Message.confirmDelete'), this.$t('Message.tip'), {
                type: 'warning'
            })
            .then(() => {
                let params = {
                    fathersssid: localStorage.getItem('sssid'),
                    delsssid: row.sssid
                };
                api.deleteUser(params)
                .then(res => {
                    if(res.state) {
                        this.$message.success(this.$t('Message.delete'));
                        this.getData();
                    } else {
                        this.$message.error(res.value.text);
                    }
                })
                .catch((error) => {
                    this.$message.error(this.$t('Message.reqError'));
                }); 
            })
            .catch(() => {});
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 多选删除
        delAllSelection() {
            if(this.multipleSelection.length < 1){
                this.$message.warning(this.$t('Message.selectDeleteItem'));
                return;
            }              
            // 二次确认删除
            this.$confirm(this.$t('Message.confirmDelete'), this.$t('Message.tip'), {
                type: 'warning'
            })
            .then(() => {    
                let successcount = 0;
                let failinfo = "";
                this.multipleSelection.forEach(item => {
                    let params = {
                        fathersssid: localStorage.getItem('sssid'),
                        delsssid: item.sssid
                    };
                    api.deleteUser(params)                    
                    .then(res => {
                        if(res.state) {
                            successcount++;
                        } else {
                            if(failinfo == "") {
                                failinfo += item.account;
                            } else {
                                failinfo += "," + item.account;
                            }
                            
                        }
                    })
                    .catch((error) => {
                        if(failinfo == "") {
                            failinfo += item.account;
                        } else {
                            failinfo += "," + item.account;
                        }

                    });                     
                });

                setTimeout(() => {
                    if(failinfo == ""){
                        this.$message.success(this.$t('Message.delete'));
                        this.getData();
                    } else {
                        this.$message.error(failinfo + this.$t('Message.deleteFail'));
                    }
                }, 1000);
            })
            .catch(() => {});
        },

        // 编辑
        handleEdit(row) {
            this.$router.push({path:'/userEdit', query:{row: JSON.stringify(row)}});
        },

        //点击进入详情页
        handleDetail(detail) {
            // this.$router.push({path:'/', query:{id:detail.id}});
        },

        //当前显示条数
        handleCurentChange(val) {
            this.curPage = val;
        },
        //设置每页显示条数                 
        handleSizeChange(val){
            this.pagesize = val;
        },

        //导出
        // getExport(){           
        //     let id = localStorage.getItem('sssid');
        //     let accountemail = "";
        //     if(this.query.input !== "") {
        //         accountemail = '&accountemail=' + this.query.input;
        //     }
        //     let nickname = "";
        //     if(this.query.company !== "") {
        //         nickname = '&nickname=' + this.query.company;
        //     }
        //     let time = "";
        //     if(this.query.createTime){
        //         time = '&beginrtime=' + this.query.createTime[0] + '&endrtime=' + this.query.createTime[1];
        //     }
        //     return this.GLOBAL.serverSrc + 'User/DownloadExcel?filename=data&usersssid='+id+accountemail+nickname+time;
        // },  

        //导出
        handleExport(){
            let id = localStorage.getItem('sssid');
            let accountemail = "";
            if(this.query.input !== "") {
                accountemail = '&accountemail=' + this.query.input;
            }
            let nickname = "";
            if(this.query.company !== "") {
                nickname = '&nickname=' + this.query.company;
            }
            let time = "";
            if(this.query.createTime){
                time = '&beginrtime=' + this.query.createTime[0] + '&endrtime=' + this.query.createTime[1];
            }
            let url = this.GLOBAL.serverSrc + 'User/DownloadExcel?filename=data&includeSelf=false&usersssid='+id+accountemail+nickname+time;

            api.download(this, url, this.$t('Export.user'));
        },

        changeStatus(callback) {
            let params = {
                fathersssid: localStorage.getItem('sssid')
            };
            api.editUser(params, callback)
            .then(res => {
                this.loading = false;
                if(res.state){
                    this.$message.success(this.$t('Message.edit'));
                } else {
                    this.$message.error(res.value.text);
                }
            })            
        }
        
    }
};
</script>

<style scoped>
.searchWidth{
    width: 150px;
}

.timeWidth{
    width: 335px;
}
</style>





